
import React from 'react';

const Home = () => {
  return (
    <div
      className="ctm-homepage"
      style={{ position: 'absolute', height: '100%', width: '100%' }}
    >
       <img src={`${process.env.PUBLIC_URL}/images/home_page.jpg`} alt="Logo" style={{ height: '100%', width: '100%' }} />
      
    </div>
  );
};

export default Home;
